import { Popup } from 'devextreme-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { DxReportViewer } from 'devexpress-reporting/dx-webdocumentviewer';
import * as ko from 'knockout';
import { ReportStruct, ReportType } from '../../../types/types.reports';
import deCore from '../../../localization/dx-analytics-core.es.json';
import deRep from '../../../localization/dx-reporting.es.json';
import { useAppSelector } from '../../../contexts/hooks';
import { setDxReportingAuth } from '../../../utils/dxReportingAuth';

export const ModalReportPreorden = ({ idPreorden, visible, setVisible, reportName }: { idPreorden: number; visible: boolean; setVisible: ({ visible }) => void; reportName: string }) => {
  const viewerRef = useRef<HTMLDivElement>(null);
  const token = useAppSelector((x) => x.userInfo.Token);
  const [requestOptions, setRequestOptions] = useState({
    host: '',
    invokeAction: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/config.json');
        const data = await response.json();
        setRequestOptions({ host: `${data.apiUrl}/`, invokeAction: 'DXXRDV' });
      } catch (error) {
        console.error('Error fetching config data:', error);
      }
    };
    if (visible) {
      fetchData();
    }
  }, [visible]);

  useEffect(() => {
    if (!viewerRef.current || idPreorden === -1 || !requestOptions.host || !visible) {
      return;
    }

    const myReport: ReportStruct = { Name: reportName, Type: ReportType.System, Data: [idPreorden] };
    const reportUrl = ko.observable(JSON.stringify(myReport));
    setDxReportingAuth(token);
    const viewer = new DxReportViewer(viewerRef.current, {
      reportUrl,
      requestOptions,
      callbacks: {
        CustomizeMenuActions: (s, e) => {
          // Habilitar vista multipágina (scroll continuo)
          const multipageButton = e.Actions.find((x) => x.id === 'dxxrp-multipage-toggle');
          if (multipageButton) {
            multipageButton.clickAction();
          }
          var search = e.Actions.find((x) => x.id === 'dxxrp-search');
          if (search) {
            search.visible = false;
          }
          var editingFields = e.Actions.find((x) => x.id === 'dxxrp-highlight-editing-fields');
          if (editingFields) {
            editingFields.visible = false;
          }

          var exportMenu = e.Actions.find((x) => x.id === 'dxxrp-export-menu');
          if (exportMenu) {
            exportMenu.visible = false;
          }

          var printPage = e.Actions.find((x) => x.id === 'dxxrp-print-page');
          if (printPage) {
            printPage.visible = false;
          }
        },
        CustomizeExportOptions: (s, e) => {
          e.HideExportOptionsPanel();
        },

        CustomizeLocalization: (s, e) => {
          e.LoadMessages(deCore);
          e.LoadMessages(deRep);
          s.UpdateLocalization({
            'Preview Parameters': 'Parámetros',
            Reset: 'Limpiar',
          });
        },
      },
    });
    viewer.render();
    return () => viewer.dispose();
  }, [idPreorden, requestOptions, token]);

  const handleVisible = useCallback(() => {
    setVisible({ visible: false });
  }, []);

  return (
    <Popup visible={visible} fullScreen={true} onHidden={handleVisible} title='Imprimir Recibo de Caja' showCloseButton={true}>
      <div style={{ width: '100%', height: '100%' }}>
        <div ref={viewerRef}></div>
      </div>
    </Popup>
  );
};
